// import { useEffect, useRef, useState } from 'react';
// import { useNavigate, useLocation, useParams } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import { constants } from '../../config/constants';
// import { httpInterceptor } from '../../API/interceptor';

// import AddIconWhite from '../../assets/icons/iconAddWhite.svg';
// import './style.scss';

// import { useLoader } from '../../contexts/loader/loader';
// import { saveExplorationEvidence, getExplorationBySchool } from '../../API/apiService';

// function ExplorationEvidence() {
//   const { show } = useLoader();
//   const navigate = useNavigate();

//   // Ruta: /exploracion/:schoolId
//   const { schoolId } = useParams();

//   const [buttonDisabled, setButtonDisabled] = useState(false);

//   // Info del formulario
//   const [info, setInfo] = useState({
//     meetingDate: '',
//     goal: '',
//     notes: '',
//     edit: false
//   });

//   // Guardar meetingGroupId para update
//   const [meetingGroupId, setMeetingGroupId] = useState(null);

//   const inputRefs = useRef([]);
//   const setInputRef = (index, ref) => {
//     inputRefs.current[index] = ref;
//   };

//   // Igual que SingleMeeting
//   // const baseURL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
//   function joinUrl(base, path) {
//     const b = String(base || '').replace(/\/+$/, '');   // quita / al final
//     const p = String(path || '').replace(/^\/+/, '');   // quita / al inicio
//     return `${b}/${p}`;
//   }


//   const [images, setImages] = useState([
//     { imageUrl: '', id: 0, updated: false, base64: null, externalId: null, savedInDB: false },
//     { imageUrl: '', id: 1, updated: false, base64: null, externalId: null, savedInDB: false }
//   ]);

//   function handleImageClick(index) {
//     if (inputRefs.current[index]) inputRefs.current[index].click();
//   }

//   function handleCaptureImage(target, identifier) {
//     if (!target.files || target.files.length === 0) return;

//     const file = target.files[0];
//     const newUrl = URL.createObjectURL(file);
//     const updatedImageList = [...images];

//     const reader = new FileReader();
//     reader.readAsDataURL(file);

//     const img = updatedImageList.find(a => a.id === identifier);

//     reader.onload = () => {
//       const imageObj = new Image();
//       imageObj.src = reader.result;

//       imageObj.onload = () => {
//         const canvas = document.createElement('canvas');
//         const maxWidth = 800;
//         const maxHeight = 600;

//         let width = imageObj.width;
//         let height = imageObj.height;

//         if (width > height) {
//           if (width > maxWidth) {
//             height *= maxWidth / width;
//             width = maxWidth;
//           }
//         } else {
//           if (height > maxHeight) {
//             width *= maxHeight / height;
//             height = maxHeight;
//           }
//         }

//         canvas.width = width;
//         canvas.height = height;

//         const ctx = canvas.getContext('2d');
//         ctx.drawImage(imageObj, 0, 0, width, height);

//         const resizedBase64 = canvas.toDataURL('image/jpeg');

//         if (img) {
//           img.base64 = resizedBase64;
//         }
//       };
//     };

//     if (img) {
//       img.imageUrl = newUrl;
//       img.updated = true;
//       img.savedInDB = false;        // ahora es nueva versiÃ³n
//       img.externalId = null;        // porque es nueva
//     }

//     setImages(updatedImageList);
//   }

//   function addInfo(value, key) {
//     if ((key === 'goal' || key === 'notes') && value?.length > 255) {
//       value = value.substring(0, 255);
//     }
//     setInfo(prev => ({ ...prev, [key]: value }));
//   }

//   async function getInfoBySchool(sId) {
//     const exp = await getExplorationBySchool(Number(sId));

//     if (!exp) return;

//     setMeetingGroupId(exp.meetingGroupId ?? null);

//     // fecha sin T
//     const d = String(exp.meetingDate || '');
//     const idx = d.indexOf('T');
//     const meetingDate = idx > 0 ? d.substring(0, idx) : d;

//     setInfo({
//       meetingDate,
//       goal: exp.goal ?? '',
//       notes: exp.notes ?? ''
//     });

//     // âœ… NO uses exp.images[i].path porque es /srv/public...
//     // usa el endpoint /image?imageId=... como SingleMeeting
//     const imgsRaw = Array.isArray(exp.images) ? exp.images : [];

//     const apiBase = ((process.env.REACT_APP_API_URL || '').replace(/\/+$/, '') + '/api/v1');

//     const imgs = imgsRaw.map((a, i) => ({
//       imageUrl: `${joinUrl(apiBase, 'image')}?imageId=${a.id}&thumbnail=${!!a.thumbnail}`,
//       id: i,
//       updated: true,
//       base64: null,
//       externalId: a.id,
//       savedInDB: true
//     }));

//     while (imgs.length < 2) {
//       imgs.push({
//         imageUrl: '',
//         id: imgs.length,
//         updated: false,
//         base64: null,
//         externalId: null,
//         savedInDB: false
//       });
//     }

//     setImages(imgs.slice(0, 2));
//   }


//   useEffect(() => {
//   if (!schoolId) return;
//     getInfoBySchool(schoolId);
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [schoolId]);


//   async function onSave() {
//     if (!schoolId) {
//       toast('Falta el ID del colegio en la ruta', { type: 'error' });
//       return;
//     }
//     if (!info.meetingDate) {
//       toast('Seleccione una fecha', { type: 'warning' });
//       return;
//     }
//     if (!info.goal) {
//       toast('Debe definir un objetivo', { type: 'warning' });
//       return;
//     }

//     const selectedImages = images.filter(i => i.base64);
//     const hasExistingDbImages = images.some(i => i.savedInDB && i.imageUrl);

//     if (selectedImages.length === 0 && !hasExistingDbImages) {
//       toast('Debe subir mÃ­nimo 1 registro fotogrÃ¡fico', { type: 'warning' });
//       return;
//     }

//     const payload = {
//       schoolId: Number(schoolId),
//       meetingGroupId: meetingGroupId ?? undefined, // si existe, backend actualiza
//       meetingDate: info.meetingDate,
//       goal: info.goal,
//       notes: info.notes,
//       userId: Number(localStorage.getItem(constants.USER_ID)),
//       images: selectedImages.map(i => ({ base64: i.base64 }))
//     };

//     setButtonDisabled(true);
//     await show(true);

//     const ok = await saveExplorationEvidence(payload);

//     await show(false);
//     setButtonDisabled(false);

//     if (ok) {
//       toast('Evidencias guardadas correctamente', { type: 'success' });
//       navigate(-1);
//     } else {
//       toast('No se pudieron guardar las evidencias', { type: 'error' });
//     }
//   }

//   return (
//     <section className='singleMetting-main-container'>
//       <div className='principal-container'>
//         <div className='title-container'>
//           <p className='description'>Evidencias de concertaciÃ³n</p>
//         </div>

//         <div className='inputs-container'>
//           <label className='input-date-container'>
//             <input
//               type='date'
//               onChange={e => addInfo(e.target.value, 'meetingDate')}
//               className='input-form'
//               value={info.meetingDate}
//             />
//           </label>

//           <label className='input-area-container'>
//             <textarea
//               placeholder='Objetivo'
//               onChange={e => addInfo(e.target.value, 'goal')}
//               className='input-form'
//               value={info.goal}
//               maxLength={255}
//             />
//           </label>

//           <label className='input-area-container'>
//             <textarea
//               placeholder='Observaciones'
//               onChange={e => addInfo(e.target.value, 'notes')}
//               className='area'
//               value={info.notes}
//               maxLength={255}
//             />
//           </label>
//         </div>

//         <div className='photos-register-container'>
//           <p className='title'>Registro fotogrÃ¡fico</p>

//           <div className='assistence-photos'>
//             {images.map((imgInfo, index) => (
//               <div key={index}>
//                 {imgInfo.updated ? (
//                   <img
//                     className='photo'
//                     src={imgInfo.imageUrl}
//                     alt={`Image ${index}`}
//                     onClick={() => handleImageClick(index)}
//                   />
//                 ) : (
//                   <img
//                     className='iconWhite'
//                     src={AddIconWhite}
//                     alt={`Image ${index}`}
//                     onClick={() => handleImageClick(index)}
//                   />
//                 )}

//                 <input
//                   accept='image/*'
//                   type='file'
//                   ref={ref => setInputRef(index, ref)}
//                   capture='environment'
//                   onChange={e => handleCaptureImage(e.target, index)}
//                   style={{ display: 'none' }}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className='save-button-container'>
//           <button
//             className='blue-site-button saveAll'
//             onClick={onSave}
//             disabled={buttonDisabled}
//           >
//             GUARDAR
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default ExplorationEvidence;



import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { constants } from '../../config/constants';

import AddIconWhite from '../../assets/icons/iconAddWhite.svg';
import './style.scss';

import { useLoader } from '../../contexts/loader/loader';
import { saveExplorationEvidence, updateExplorationEvidence, getExplorationBySchool, getSchools } from '../../API/apiService';
import { buildProtectedImageUrl, fetchWithAuth } from '../../utils/secureMedia';
import { buildEvidenceDownloadName } from '../../utils/evidenceFileName';
import {
  buildCombinedEvidencePdfBlob,
  buildCombinedEvidencePdfName
} from '../../utils/combinedEvidencePdf';
import EvidencePreviewModal from '../../components/evidencePreviewModal';
import EvidenceReviewStatus from '../../components/evidenceReviewStatus';
import { resolveEvidenceSlot } from '../../utils/evidenceSlot';

function ExplorationEvidence() {
  const TOTAL_EVIDENCE_IMAGES = 3;
  const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
  const EVIDENCE_SECTIONS = [
    'Evidencia Fotografica',
    'Acta/guia',
    'Listado de asistencia'
  ];
  const { show } = useLoader();
  const navigate = useNavigate();
  const location = useLocation();

  // Ruta: /exploracion/:schoolId
  const { schoolId } = useParams();
  const stateBackTo = location?.state?.backTo;
  const evidenceSearchParams = new URLSearchParams(location.search);
  const evidenceOrigin = evidenceSearchParams.get('origin');
  const returnTo = evidenceSearchParams.get('returnTo');
  const hasAdminReadOnlyOrigin = evidenceOrigin === 'admin-evidences';
  const navigationBackTo =
    stateBackTo ||
    returnTo ||
    (hasAdminReadOnlyOrigin ? '/administrador/menu/evidencias' : null);
  const isReadOnlyView = hasAdminReadOnlyOrigin;

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [previewEvidence, setPreviewEvidence] = useState(null);

  // Info del formulario
  const [info, setInfo] = useState({
    meetingDate: '',
    goal: '',
    notes: '',
    reviewStatus: 'pending',
    reviewObservations: '',
    edit: true
  });

  // Guardar meetingGroupId para update (lo dejas si aÃºn lo usas en backend)
  const [meetingGroupId, setMeetingGroupId] = useState(null);

  // âœ… NUEVO: id real del registro de concertaciÃ³n (meeting) para hacer PUT
  const [explorationId, setExplorationId] = useState(null);
  const [schoolMeta, setSchoolMeta] = useState({
    id: null,
    code: '',
    municipalityId: null,
    groups: []
  });

  const inputRefs = useRef([]);
  const setInputRef = (index, ref) => {
    inputRefs.current[index] = ref;
  };

  const [images, setImages] = useState([
    { imageUrl: '', id: 0, updated: false, file: null, externalId: null, savedInDB: false, fileType: null, fileName: '' },
    { imageUrl: '', id: 1, updated: false, file: null, externalId: null, savedInDB: false, fileType: null, fileName: '' },
    { imageUrl: '', id: 2, updated: false, file: null, externalId: null, savedInDB: false, fileType: null, fileName: '' },
    { imageUrl: '', id: 3, updated: false, file: null, externalId: null, savedInDB: false, fileType: null, fileName: '' },
    { imageUrl: '', id: 4, updated: false, file: null, externalId: null, savedInDB: false, fileType: null, fileName: '' }
  ]);

  function closePreview() {
    setPreviewEvidence(null);
  }

  function openEvidencePreview(index) {
    const imgInfo = images[index];
    if (!imgInfo?.updated) return;

    const sourceUrl = imgInfo?.externalId
      ? buildProtectedImageUrl(imgInfo.externalId, false, Date.now())
      : imgInfo?.imageUrl;

    if (!sourceUrl) return;

    setPreviewEvidence({
      sourceUrl,
      fileType: imgInfo?.fileType === 'pdf' ? 'pdf' : 'image',
      fileName: getEvidenceDisplayName(imgInfo, index)
    });
  }

  function handleImageClick(index) {
    if (isReadOnlyView) {
      openEvidencePreview(index);
      return;
    }

    const fileInput = inputRefs.current[index];
    if (!fileInput) return;
    fileInput.value = '';
    fileInput.click();
  }

  function navigateToBackTarget() {
    if (!navigationBackTo) return false;

    if (typeof navigationBackTo === 'string') {
      navigate(navigationBackTo, { replace: true });
      return true;
    }

    if (typeof navigationBackTo === 'object' && navigationBackTo.pathname) {
      navigate(navigationBackTo.pathname, {
        state: navigationBackTo.state,
        replace: true
      });
      return true;
    }

    return false;
  }

  function normalizeFileType(file) {
    const mime = String(file?.type || '').toLowerCase();
    const name = String(file?.name || '').toLowerCase();

    if (mime === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';

    if (
      mime === 'image/jpeg' ||
      mime === 'image/jpg' ||
      name.endsWith('.jpeg') ||
      name.endsWith('.jpg')
    ) {
      return 'image';
    }

    return null;
  }

  function resolveExplorationSlot(imageName, fallbackSlot) {
    return resolveEvidenceSlot(imageName, fallbackSlot, TOTAL_EVIDENCE_IMAGES);
  }

  function handleCaptureImage(target, identifier) {
    if (!target.files || target.files.length === 0) return;

    const file = target.files[0];
    const detectedType = normalizeFileType(file);
    if (!detectedType) {
      toast('Solo se permiten archivos PDF, JPG o JPEG', { type: 'warning' });
      target.value = '';
      return;
    }
    if (file.size > MAX_FILE_SIZE_BYTES) {
      toast('Cada archivo debe pesar maximo 10MB', { type: 'warning' });
      target.value = '';
      return;
    }
    const newUrl = URL.createObjectURL(file);
    setImages(prevImages =>
      prevImages.map(currentImage =>
        currentImage.id === identifier
          ? {
              ...currentImage,
              imageUrl: newUrl,
              updated: true,
              file,
              fileType: detectedType,
              fileName: file.name || '',
              savedInDB: false,
              externalId: null
            }
          : currentImage
      )
    );
  }

  function addInfo(value, key) {
    if (key === 'goal' && value?.length > 2000) {
      value = value.substring(0, 2000);
    }
    if (key === 'notes' && value?.length > 255) {
      value = value.substring(0, 255);
    }
    setInfo(prev => ({ ...prev, [key]: value }));
  }

  async function loadSchoolMeta(sId) {
    const parsedId = Number(sId);
    if (!parsedId) return;
    if (schoolMeta?.id === parsedId) return;

    const schools = await getSchools();
    const match = Array.isArray(schools)
      ? schools.find(s => Number(s?.id) === parsedId)
      : null;
    if (!match) return;

    setSchoolMeta({
      id: parsedId,
      code: match?.code ?? '',
      municipalityId:
        match?.municipalityId ??
        match?.municipality_id ??
        match?.municipality?.id ??
        null,
      groups: Array.isArray(match?.groups) ? match.groups : []
    });
  }

  const [groupId, setGroupId] = useState(null); 

  async function getInfoBySchool(sId, { retry = true } = {}) {
    await loadSchoolMeta(sId);
    const exp = await getExplorationBySchool(Number(sId));

    if (!exp && retry) {
      await new Promise(resolve => setTimeout(resolve, 300));
      return getInfoBySchool(sId, { retry: false });
    }

    if (!exp) return;

    // Guarda el ID para poder hacer UPDATE (PUT) - usar meetingGroupId
    setExplorationId(exp.meetingGroupId ?? null);
    setGroupId(exp.groupId ?? null);
    setMeetingGroupId(exp.meetingGroupId ?? null);

    // fecha sin T
    const d = String(exp.meetingDate || '');
    const idx = d.indexOf('T');
    const meetingDate = idx > 0 ? d.substring(0, idx) : d;

    setInfo({
      meetingDate,
      goal: exp.goal ?? '',
      notes: exp.notes ?? '',
      reviewStatus: exp.reviewStatus ?? 'pending',
      reviewObservations: exp.reviewObservations ?? ''
    });

    // usa el endpoint /image?imageId=... como SingleMeeting
    const imgsRaw = Array.isArray(exp.images) ? exp.images : [];

    const imgs = Array.from({ length: TOTAL_EVIDENCE_IMAGES }, (_, index) => ({
      imageUrl: '',
      id: index,
      updated: false,
      file: null,
      externalId: null,
      savedInDB: false,
      fileType: null,
      fileName: ''
    }));

    const cacheKey = Date.now();
    imgsRaw.forEach((a, index) => {
      const fallbackSlot = Math.min(index + 1, TOTAL_EVIDENCE_IMAGES);
      const slot = resolveExplorationSlot(a?.name, fallbackSlot);
      const slotIndex = slot - 1;

      imgs[slotIndex] = {
        imageUrl: buildProtectedImageUrl(a.id, !!a.thumbnail, cacheKey),
        id: slotIndex,
        updated: true,
        file: null,
        externalId: a.id,
        savedInDB: true,
        fileType: a.type === 'pdf' ? 'pdf' : 'image',
        fileName: a.name ?? ''
      };
    });

    setImages(imgs);
  }

  useEffect(() => {
    if (!schoolId) return;
    getInfoBySchool(schoolId, { retry: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId]);

  async function onSave() {
    if (!schoolId) {
      toast('Falta el ID del colegio en la ruta', { type: 'error' });
      return;
    }
    if (!info.meetingDate) {
      toast('Seleccione una fecha', { type: 'warning' });
      return;
    }
    if (!info.goal) {
      toast('Debe definir un objetivo', { type: 'warning' });
      return;
    }

    const selectedImages = images.filter(i => i.file);

    setButtonDisabled(true);
    await show(true);

    let ok = false;

    try {
      // âœ… FALLBACK ANTI-DUPLICADOS:
      // Si explorationId estÃ¡ vacÃ­o por timing, consultamos justo antes de guardar
      let idToUpdate = explorationId;


      if (!idToUpdate) {
        const expNow = await getExplorationBySchool(Number(schoolId));
        if (expNow?.meetingGroupId) {
          idToUpdate = expNow.meetingGroupId;
          setExplorationId(expNow.meetingGroupId); // dejamos el state consistente
        }
      }


      // âœ… Construir payload segÃºn operaciÃ³n (CREATE vs UPDATE)
      const payload = {
        schoolId: Number(schoolId),
        groupId,
        meetingGroupId: meetingGroupId ?? undefined,
        meetingDate: info.meetingDate,
        goal: info.goal,
        notes: info.notes,
        userId: Number(localStorage.getItem(constants.USER_ID))
      };

      // âœ… UPDATE si ya existe
      if (idToUpdate) {
        // Solo incluir 'images' si hay nuevas (preserva las existentes si no se envÃ­a)
        if (selectedImages.length > 0) {
          payload.images = selectedImages.map(i => ({
            file: i.file,
            slot: Number(i.id) + 1
          }));
        }
        ok = await updateExplorationEvidence(idToUpdate, payload);
      } else {
        payload.images = selectedImages.map(i => ({
          file: i.file,
          slot: Number(i.id) + 1
        }));
        ok = await saveExplorationEvidence(payload);

        // opcional: asegurar que en adelante ya tenga ID para futuros updates
        if (ok) {
          const expAfter = await getExplorationBySchool(Number(schoolId));
          if (expAfter?.meetingGroupId) setExplorationId(expAfter.meetingGroupId);
        }
      }
    } catch (err) {
      console.error('SAVE/UPDATE ERROR:', err);
      ok = false;
    }

    await show(false);
    setButtonDisabled(false);

    if (ok) {
      toast('Evidencias guardadas correctamente', { type: 'success' });
      if (navigateToBackTarget()) {
        return;
      }
      navigate(-1);
    } else {
      toast('No se pudieron guardar las evidencias', { type: 'error' });
    }
  }

  function onCancel() {
    if (navigateToBackTarget()) {
      return;
    }
    navigate('/registrarEscuelas');
  }

  function downloadBlob(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }

  function getSelectedGroupCode() {
    const groups = Array.isArray(schoolMeta?.groups) ? schoolMeta.groups : [];
    const selectedGroup = groups.find(
      group => String(group?.id ?? '') === String(groupId ?? '')
    );

    return String(selectedGroup?.code || '').trim();
  }

  function getEvidenceName(imgInfo, index) {
    const ext = imgInfo?.fileType === 'pdf' ? 'pdf' : 'jpg';
    const municipalityId = schoolMeta?.municipalityId;
    const schoolCode = String(schoolMeta?.code || '').trim();
    const groupCode = getSelectedGroupCode();
    const prefix = index === 3
      ? 'Req'
      : index === 4
        ? 'Refri'
        : index === 1
          ? 'AcC'
          : index === 2
            ? 'AsC'
            : 'C';

    return buildEvidenceDownloadName({
      prefix,
      evidenceType: 'CONC',
      municipalityId,
      meetingDate: info.meetingDate,
      orderValue: 1,
      schoolCode,
      groupCode,
      extension: ext,
      fallbackFileName: imgInfo?.fileName,
      fallbackIndex: index + 1
    });
  }

  function getEvidenceDisplayName(imgInfo, index) {
    const raw = String(imgInfo?.fileName || '').trim();
    if (!raw) return imgInfo?.updated ? `evidencia_${index + 1}` : '';
    return raw.split(/[\\/]/).pop() || raw;
  }

  function getDownloadableEvidences() {
    return images
      .map((img, index) => ({ ...img, index }))
      .filter(img => img.updated && (img.imageUrl || img.file));
  }

  function getOriginalEvidenceUrl(evidence) {
    return evidence?.externalId
      ? buildProtectedImageUrl(evidence.externalId, false)
      : evidence?.imageUrl;
  }

  function getCombinedEvidenceName(evidences) {
    const firstEvidence = evidences?.[0];
    const firstName = firstEvidence
      ? getEvidenceName({ ...firstEvidence, fileType: 'pdf' }, firstEvidence.index)
      : '';

    return buildCombinedEvidencePdfName(firstName, 'evidencias_concertacion');
  }

  async function onDownloadEvidences() {
    const evidences = getDownloadableEvidences();

    if (evidences.length === 0) {
      toast('No hay evidencias para descargar', { type: 'warning' });
      return;
    }

    setButtonDisabled(true);
    await show(true);

    try {
      for (const evidence of evidences) {
        const fileName = getEvidenceName(evidence, evidence.index);

        if (evidence.file) {
          downloadBlob(evidence.file, fileName);
          continue;
        }

        const originalUrl = getOriginalEvidenceUrl(evidence);

        if (originalUrl) {
          const response = await fetchWithAuth(originalUrl, { credentials: 'include' });
          if (!response.ok) {
            throw new Error(`DOWNLOAD_FAILED_${response.status}`);
          }
          const blob = await response.blob();
          downloadBlob(blob, fileName);
        }
      }

      toast('Descarga de evidencias iniciada', { type: 'success' });
    } catch (error) {
      console.error('DOWNLOAD_EVIDENCES_ERROR', error);
      toast('No se pudieron descargar las evidencias', { type: 'error' });
    }

    await show(false);
    setButtonDisabled(false);
  }

  async function onDownloadUnifiedEvidences() {
    const evidences = getDownloadableEvidences();

    if (evidences.length === 0) {
      toast('No hay evidencias para descargar', { type: 'warning' });
      return;
    }

    setButtonDisabled(true);
    await show(true);

    try {
      const pdfBlob = await buildCombinedEvidencePdfBlob(
        evidences.map(evidence => ({
          file: evidence.file,
          fileType: evidence.fileType,
          fileName: evidence.fileName || getEvidenceName(evidence, evidence.index),
          sourceUrl: evidence.file ? '' : getOriginalEvidenceUrl(evidence)
        }))
      );

      downloadBlob(pdfBlob, getCombinedEvidenceName(evidences));
      toast('Descarga unida iniciada', { type: 'success' });
    } catch (error) {
      console.error('DOWNLOAD_UNIFIED_EVIDENCES_ERROR', error);
      toast('No se pudo generar el PDF unido', { type: 'error' });
    }

    await show(false);
    setButtonDisabled(false);
  }

  return (
    <section className='singleMetting-main-container'>
      <EvidencePreviewModal
        open={Boolean(previewEvidence?.sourceUrl)}
        sourceUrl={previewEvidence?.sourceUrl}
        fileType={previewEvidence?.fileType}
        fileName={previewEvidence?.fileName}
        onClose={closePreview}
      />
      <div className='principal-container'>
        <div className='title-container'>
          <p className='description'>Evidencias de concertación</p>
          <EvidenceReviewStatus
            status={info.reviewStatus}
            observations={info.reviewObservations}
          />
        </div>

        <div className='inputs-container'>
          <label className='input-date-container'>
            <input
              type='date'
              onChange={e => addInfo(e.target.value, 'meetingDate')}
              className='input-form'
              value={info.meetingDate}
              disabled={isReadOnlyView}
            />
          </label>

          <label className='input-area-container'>
            <textarea
              placeholder='Objetivo'
              onChange={e => addInfo(e.target.value, 'goal')}
              className='input-form'
              value={info.goal}
              maxLength={2000}
              readOnly={isReadOnlyView}
            />
          </label>

          <label className='input-area-container'>
            <textarea
              placeholder='Observaciones'
              onChange={e => addInfo(e.target.value, 'notes')}
              className='area'
              value={info.notes}
              maxLength={255}
              readOnly={isReadOnlyView}
            />
          </label>
        </div>

        <div className='photos-register-container'>
          <p className='title'>Evidencias</p>

          <div className='assistence-photos evidence-groups'>
            {EVIDENCE_SECTIONS.map((sectionTitle, index) => {
              const imgInfo = images[index] || {
                id: index,
                updated: false,
                imageUrl: '',
                fileType: null,
                externalId: null,
                fileName: ''
              };
              const evidenceLabel = getEvidenceDisplayName(imgInfo, index);
              return (
              <div key={sectionTitle} className='evidence-group'>
                <p className='evidence-group__title'>{sectionTitle}</p>
                <div className='evidence-item'>
                {imgInfo.updated ? (
                  imgInfo.fileType === 'pdf' ? (
                    <button
                      type='button'
                      className='photo pdf-preview'
                      onClick={() => handleImageClick(index)}
                    >
                      PDF
                    </button>
                  ) : (
                    <img
                      className='photo'
                      src={imgInfo.imageUrl}
                      alt={`Evidencia ${index + 1}`}
                      onClick={() => handleImageClick(index)}
                    />
                  )
                ) : (
                  <img
                    className='iconWhite'
                    src={AddIconWhite}
                    alt={`Evidencia ${index + 1}`}
                    onClick={() => handleImageClick(index)}
                  />
                )}
                <p
                  className='evidence-file-name'
                  title={evidenceLabel}>
                  {evidenceLabel}
                </p>

                {imgInfo.updated && (
                  <button
                    type='button'
                    className='evidence-preview-button'
                    onClick={() => openEvidencePreview(index)}
                  >
                    PREVISUALIZAR
                  </button>
                )}

                <input
                  accept='image/*,.pdf,application/pdf,.jpg,.jpeg,image/jpeg,image/jpg'
                  type='file'
                  ref={ref => setInputRef(index, ref)}
                  onChange={e => handleCaptureImage(e.target, index)}
                  style={{ display: 'none' }}
                />
                </div>
              </div>
            )})}
          </div>
        </div>
        <div className='save-button-container'>
          {!isReadOnlyView && (
            <button
              className='blue-site-button saveAll'
              onClick={onSave}
              disabled={buttonDisabled}
            >
              GUARDAR
            </button>
          )}
          <button
            className='button-white-border-blue download-btn'
            onClick={onDownloadEvidences}
            disabled={buttonDisabled}
          >
            DESCARGAR EVIDENCIAS
          </button>
          <button
            className='button-white-border-blue download-btn'
            onClick={onDownloadUnifiedEvidences}
            disabled={buttonDisabled}
          >
            DESCARGAR UNIDO
          </button>
          <button
            className='button-white-border-blue cancel-btn'
            onClick={onCancel}
            disabled={buttonDisabled}
          >
            {isReadOnlyView ? 'VOLVER' : 'CANCELAR'}
          </button>
        </div>
      </div>
    </section>
  );
}

export default ExplorationEvidence;

